var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgG10(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "g10",
    xmlns: "http://www.w3.org/2000/svg",
    width: 196.467,
    height: 48.715,
    viewBox: "0 0 196.467 48.715",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path14",
    d: "M362.2-202.15h3.862v28.963H362.2V-202.15",
    transform: "translate(-289.331 210.195)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path16",
    d: "M416.543-202.952a15.393,15.393,0,0,0-2.354.133,13.207,13.207,0,0,0-3.281.9,14.262,14.262,0,0,0-4.735,3.241,14.352,14.352,0,0,0-3.221,4.755,14.582,14.582,0,0,0-1.067,5.628,14.488,14.488,0,0,0,1.067,5.628,13.9,13.9,0,0,0,3.221,4.735,14.268,14.268,0,0,0,4.735,3.221,14.222,14.222,0,0,0,5.539,1.066v0h.069a14.339,14.339,0,0,0,5.609-1.068,15.025,15.025,0,0,0,4.754-3.221,12.746,12.746,0,0,0,2.426-3.224,13.334,13.334,0,0,0,.746-1.511,13.947,13.947,0,0,0,.975-3.729,15.794,15.794,0,0,0,.112-1.9v-1.9l0,0v0H417.455v3.8h9.638a9.966,9.966,0,0,1-.655,2.2,10.712,10.712,0,0,1-2.38,3.478,10.91,10.91,0,0,1-3.515,2.379,10.5,10.5,0,0,1-3.523.781c-.148.006-.3.009-.444.009a10.736,10.736,0,0,1-4.114-.8,10.383,10.383,0,0,1-3.474-2.368,10.793,10.793,0,0,1-2.348-3.474,10.742,10.742,0,0,1-.8-4.114,10.836,10.836,0,0,1,.8-4.114,11.076,11.076,0,0,1,2.348-3.474,10.654,10.654,0,0,1,3.474-2.368,10.282,10.282,0,0,1,4.114-.8,10.412,10.412,0,0,1,4.095.8,11.141,11.141,0,0,1,2.581,1.553l2.756-2.775q-.738-.582-1.281-.951A16,16,0,0,0,422.2-201.8a14.41,14.41,0,0,0-2.736-.854,13.8,13.8,0,0,0-2.924-.3",
    transform: "translate(-321.03 210.835)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path18",
    d: "M584.213-202.25v3.842H571.657v8.733h9.412v3.843h-9.412v8.733h12.556v3.843H567.795V-202.25h16.418",
    transform: "translate(-453.561 210.275)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path20",
    d: "M684.026-181.905l14.109-21.6v29.236h-3.862v-16.467L684.026-175l-10.247-15.739v16.467h-3.862V-203.5l14.109,21.6",
    transform: "translate(-535.138 211.277)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path22",
    d: "M841.2-198.423a10.957,10.957,0,0,0-3.454,2.368,10.652,10.652,0,0,0-2.368,3.474,10.782,10.782,0,0,0-.776,4.114,10.6,10.6,0,0,0,.776,4.114,10.261,10.261,0,0,0,2.368,3.474,9.933,9.933,0,0,0,3.454,2.348,10.785,10.785,0,0,0,4.133.8,10.59,10.59,0,0,0,4.095-.8,10.643,10.643,0,0,0,3.474-2.348,10.643,10.643,0,0,0,2.368-3.474,10.242,10.242,0,0,0,.815-4.114,10.422,10.422,0,0,0-.815-4.114,11.524,11.524,0,0,0-2.348-3.474,11.283,11.283,0,0,0-3.493-2.368,10.6,10.6,0,0,0-4.095-.8A10.79,10.79,0,0,0,841.2-198.423Zm9.742-3.629a15.031,15.031,0,0,1,4.755,3.26,14.674,14.674,0,0,1,3.241,4.735,14.545,14.545,0,0,1,1.087,5.628,14.453,14.453,0,0,1-1.087,5.628,14.4,14.4,0,0,1-3.241,4.735,14.615,14.615,0,0,1-4.755,3.221,14.721,14.721,0,0,1-5.609,1.067,14.676,14.676,0,0,1-5.628-1.067,14.273,14.273,0,0,1-4.735-3.221,13.967,13.967,0,0,1-3.221-4.755,14.25,14.25,0,0,1-1.068-5.609,14.341,14.341,0,0,1,1.068-5.609,14.683,14.683,0,0,1,3.221-4.774,14.679,14.679,0,0,1,4.735-3.241,14.312,14.312,0,0,1,5.628-1.067,14.353,14.353,0,0,1,5.609,1.067",
    transform: "translate(-663.562 210.969)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path24",
    d: "M3.351-131.068a1.022,1.022,0,0,1-.728-.3L.3-133.692a1.031,1.031,0,0,1,0-1.456l2.322-2.321a1.03,1.03,0,0,1,1.456,0L6.4-135.148a1.023,1.023,0,0,1,.3.728,1.023,1.023,0,0,1-.3.728L4.079-131.37a1.024,1.024,0,0,1-.728.3",
    transform: "translate(0 158.768)",
    fill: "#4f4c4c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path26",
    d: "M104.662-56.335a3.285,3.285,0,0,1-2.085-.9l-8.044-8.08,3.808-3.826.214.215a3.283,3.283,0,0,0,2.085.9,2.692,2.692,0,0,0,1.936-.9l1.592-1.6L112-62.658l-5.4,5.425a2.693,2.693,0,0,1-1.936.9",
    transform: "translate(-75.514 105.05)",
    fill: "#f24daf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path28",
    d: "M37.624-217.779,33.816-221.6a2.806,2.806,0,0,1,0-4.04l15.524-15.594a2.692,2.692,0,0,1,1.936-.9,3.285,3.285,0,0,1,2.085.9l5.614,5.64L45.1-221.657a3.145,3.145,0,0,0-1.865-.708,2.691,2.691,0,0,0-1.936.9l-3.671,3.688",
    transform: "translate(-26.298 242.137)",
    fill: "#298752"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path30",
    d: "M115.761-76.9a3.283,3.283,0,0,1-2.085-.9l-.214-.215,3.6-3.619L119.29-79.4,117.7-77.8a2.692,2.692,0,0,1-1.936.9",
    transform: "translate(-90.635 113.923)",
    fill: "#f68ccb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path32",
    d: "M170.118-197.032a3.282,3.282,0,0,1-2.085-.9l-1.806-1.814,6.1-6.129a2.806,2.806,0,0,0,0-4.04l-5.819-5.846,5.819-5.846a2.806,2.806,0,0,0,0-4.04l-9.909-9.955,5.614-5.64a2.691,2.691,0,0,1,1.936-.9,3.284,3.284,0,0,1,2.085.9L191.6-221.6a2.806,2.806,0,0,1,0,4.04L172.054-197.93a2.692,2.692,0,0,1-1.936.9",
    transform: "translate(-129.742 242.137)",
    fill: "#bfdf14"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path34",
    d: "M150.258-95.012l-7.83-7.866,8.112-8.149,5.819,5.846a2.806,2.806,0,0,1,0,4.04l-6.1,6.129",
    transform: "translate(-113.773 137.404)",
    fill: "#f68ccb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path36",
    d: "M111.4-189.8l-5.682-5.709a3.284,3.284,0,0,0-2.085-.9,2.692,2.692,0,0,0-1.936.9l-4.022,4.04-4.022-4.04a2.614,2.614,0,0,0-.221-.19l13.878-13.942,9.909,9.955a2.806,2.806,0,0,1,0,4.04L111.4-189.8",
    transform: "translate(-74.638 216.18)",
    fill: "#4aa438"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path38",
    d: "M120.137-129.109l-2.225-2.235.069-.069a2.806,2.806,0,0,0,0-4.04l-3.458-3.474,4.022-4.04a2.692,2.692,0,0,1,1.936-.9,3.284,3.284,0,0,1,2.085.9l5.682,5.709-8.112,8.149",
    transform: "translate(-91.482 163.635)",
    fill: "#fabde1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path40",
    d: "M43.382-104.79a3.284,3.284,0,0,1-2.085-.9l-7.48-7.514a2.806,2.806,0,0,1,0-4.04l3.808-3.826,6.033,6.06-1.8,1.806a2.806,2.806,0,0,0,0,4.04l3.458,3.474h0a2.693,2.693,0,0,1-1.937.9",
    transform: "translate(-26.299 145.425)",
    fill: "#842a74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path42",
    d: "M77.255-81.626,73.8-85.1a2.806,2.806,0,0,1,0-4.04l1.8-1.806,5.469,5.493-3.808,3.826",
    transform: "translate(-58.236 121.363)",
    fill: "#ef2ca0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path44",
    d: "M62.327-133.216l-6.033-6.06,3.671-3.688a2.691,2.691,0,0,1,1.936-.9,3.145,3.145,0,0,1,1.865.708l-.053.053a2.806,2.806,0,0,0,0,4.04l2.216,2.226-3.6,3.619",
    transform: "translate(-44.969 163.634)",
    fill: "#3f9779"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path46",
    d: "M91.749-99.823l-5.469-5.493,3.6-3.619,5.468,5.493-3.6,3.619",
    transform: "translate(-68.922 135.734)",
    fill: "#f466ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path48",
    d: "M91.841-134.026l-2.216-2.226a2.806,2.806,0,0,1,0-4.04l.053-.053a2.614,2.614,0,0,1,.221.19l4.022,4.04-2.079,2.089",
    transform: "translate(-70.879 160.824)",
    fill: "#62b151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path50",
    d: "M109.657-111.736l-5.468-5.493,2.079-2.089,3.458,3.474a2.806,2.806,0,0,1,0,4.04l-.069.069",
    transform: "translate(-83.227 144.028)",
    fill: "#f89fd4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path52",
    d: "M162.49-126.267a1.266,1.266,0,0,1-.9-.373l-3.851-3.851a1.266,1.266,0,0,1-.373-.9,1.265,1.265,0,0,1,.373-.9l3.851-3.851a1.305,1.305,0,0,1,1.8,0l3.851,3.851a1.265,1.265,0,0,1,.373.9,1.266,1.266,0,0,1-.373.9l-3.851,3.851a1.266,1.266,0,0,1-.9.373",
    transform: "translate(-125.705 157.757)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgG10);
export default __webpack_public_path__ + "static/media/g10.6fce349d6636a5164131d28e80ccf973.svg";
export { ForwardRef as ReactComponent };